<template>
  <tr class="search__form__header--columns">
    <th class="search__form__th--labelcode" title="Labelcode" data-parameter="labelCode" @click="sortBy" scope="col">Labelcode</th>
    <th class="search__form__th--label" title="Name des Labels" data-parameter="label" @click="sortBy" scope="col">Label</th>
    <th class="search__form__th--shortname" title="Kurzname des Labels" data-parameter="shortName" @click="sortBy" scope="col">Kurzname</th>
    <th class="search__form__th--plm" title="Musik einer Production Library / Archivmusik" data-parameter="plm" @click="sortBy" scope="col">PLM</th>
    <th class="search__form__th--producer" title="Name des Herstellers" data-parameter="companyName" @click="sortBy" scope="col">Hersteller</th>
    <th class="search__form__th--rightrecalls" title="Liste der Rechterückrufe" data-parameter="restrictions" @click="sortBy" scope="col">Rechterückrufe</th>
  </tr>
</template>

<script>
import SearchFormModel from './Model.class.ts'

export default {
  name: 'SearchHeader',
  props: {
    search: SearchFormModel
  },
  components: {
  },
  methods: {
    sortBy (evnt) {
      const element = evnt.target
      const _sortOrder = element.className.indexOf(' asc') > -1 ? 'desc' : 'asc'
      // reset any sorting
      for (let siblingIdx = 0; siblingIdx < element.parentNode.children.length; siblingIdx++) {
        element.parentNode.children[siblingIdx].className = element.parentNode.children[siblingIdx].className.replace(/(\sasc|\sdesc)/, '')
      }
      element.className = element.className + ' ' + _sortOrder
      const parameter = element.dataset.parameter
      this.search._orderBy = parameter
      this.search._sort = _sortOrder
    }
  }
}
</script>

<style lang="scss">
  .search__form__header {
    .search__form__header--columns {
      th {
        border-bottom: 1px solid black;
        border-right: 1px solid #aaa;
        position: relative;

        &:before {
          border-bottom: 0;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          border-top: 4px solid #000;
          content: "";
          margin-top: 2px;
          opacity: .3;
          position: absolute;
          right: 4px;
          top: 50%;
          visibility: visible;
        }
        &:after {
          content: "";
          border-width: 0 4px 4px;
          border-style: solid;
          border-color: #000 transparent;
          visibility: visible;
          right: 4px;
          top: 50%;
          position: absolute;
          opacity: .3;
          margin-top: -4px;
        }
        &:hover:before,
        &.asc:before,
        &:hover:after,
        &.desc:after {
          opacity: .9;
        }
      }
      th:last-child {
        border-right: none;
      }
    }
  }
</style>
